<template>
    <div class="add-attribute-wrapper">
        <div
            @click="showModal"
            class="d-flex justify-content-center align-items-center text-center p-0 mt-1 btnAddAttribute"
        >
            <span class="material-icons add-custom-attribute-plus"> add </span>
            <p class="m-0 add-custom-attribute-p">{{ $t("chatbotv2.addAttribute") }}</p>
        </div>
        <a-modal
            title=""
            wrapClassName="vertical-center-modal"
            v-model="modalVisible"
            @ok="handleOk"
            id="add-custom-attr-modal"
            :confirm-loading="loading"
        >
            <div class="add-custom-attribute-restriction row">
                <div class="col-xs-2"><span class="material-icons"> help_outline </span></div>
                <div class="col-sm-10 text-wrap">
                    {{ $t("chatbotv2.addAttributeDescription") }}
                </div>
            </div>
            <p>Attribute Name</p>
            <a-input
                placeholder="Type attribute name"
                v-model="customAttribute"
                @keydown="checkKeyDownAlphaNumeric($event)"
            />
        </a-modal>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import { mapActions, mapState } from "vuex";

const log = log2("AddCustomAttribute");
export default {
    name: "AddCustomAttribute",
    props: {
        onAdded: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            modalVisible: false,
            customAttribute: "",
            loading: false,
            storyId: window.location.pathname.split("/")[3],
        };
    },
    computed: {
        ...mapState({
            storyVersion: (state) => state.CB.selectedBoard,
        }),
    },
    methods: {
        ...mapActions({
            addCustomAttributeToBoard: "CB/addCustomAttributeToBoard",
        }),
        async handleOk() {
            this.loading = true;
            await this.addCustomAttributeToBoard({
                id: this.storyId,
                version: this.storyVersion,
                attribute: this.customAttribute,
            }).finally(() => {
                this.loading = false;
            });
            this.modalVisible = false;
            const attr = this.customAttribute;
            setTimeout(() => {
                this.onAdded(attr);
            }, 250);

            log("customAttribute", this.customAttribute);
            this.customAttribute = "";
            log("customAttribute: ", this.customAttribute);
        },
        showModal() {
            this.modalVisible = true;
        },
        checkKeyDownAlphaNumeric(event) {
            if (!/^([a-zA-Z]|[0-9]|_|-)\S*$/.test(event.key)) {
                event.preventDefault();
            }
        },
    },
    watch: {
        customAttribute: {
            deep: true,
            handler(newVal, oldVal) {
                log("input girmeye çalışılan: ", newVal);
                if (newVal === "") {
                    this.customAttribute = newVal;
                } else if (!/^([a-zA-Z]|[0-9]|_|-)+$/i.test(`${newVal}`)) {
                    this.customAttribute = oldVal;
                }
                if (newVal.includes(".") || newVal.includes("")) {
                    this.customAttribute = this.customAttribute.replace(/ /g, "");
                    this.customAttribute = this.customAttribute.replaceAll(".", "");
                }
                log("input geçerli olan: ", this.customAttribute);
            },
        },
    },
};
</script>
<style lang="scss">
#add-custom-attr-modal {
    .ant-modal-wrap {
        z-index: 999999999 !important;
    }
}
</style>

<style scoped lang="scss">
.add-custom-attribute-plus {
    color: #006cff;
    font-size: 25px;
    margin-right: 15px;
}

.add-custom-attribute-p {
    color: #22272d;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    -webkit-transition: color 0.3s;
    transition: color 0.3s;
}

.add-custom-attribute-restriction {
    background: rgb(230, 245, 255);
    margin: 10px 10px 20px 10px;
    padding: 15px;
}

.vertical-center-modal {
    text-align: center;
    white-space: nowrap;
}

.vertical-center-modal:before {
    content: "";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
    width: 0;
}

.vertical-center-modal .ant-modal {
    display: inline-block;
    vertical-align: middle;
    top: 0;
    text-align: left;
}

.btnAddAttribute {
    cursor: pointer;

    &:hover {
        p {
            color: #006cff;
        }
    }
}
</style>
